import './TitleFollowCursor.scss';
export const TitleFollowCursor = () => {
  return <span id="followDiv"></span>;
};
